import { FC } from "react";
import { Link } from "react-router-dom";
import BookmarkCard from "../BookmarkCard";
import { ICrystalConfig } from "../../data/interface";
import styles from "./index.module.css";

const CrystalCard: FC<ICrystalConfig> = ({ feature, details, img_url }) => {
  return (
    <BookmarkCard title="Firewalla Crystal" titleAlign="right" learnMoreLink="/crystal" gtmId="view_crystal">
      <Link to="/crystal" className={styles.body} data-gtm-id="view_crystal">
        <div className={styles.content}>
          <h3 className={styles.title}>{feature}</h3>
          <ol className={styles.features}>
            {details.map((detail, index) => {
              return (
                <li key={index}>
                  <img src="/images/personal-feature-check.svg" alt="Check" />
                  <span>{detail}</span>
                </li>
              );
            })}
          </ol>
        </div>
        <img className={styles.image} src={img_url} alt="Firewalla Crystal" />
      </Link>
    </BookmarkCard>
  );
};

export default CrystalCard;
